import { render, staticRenderFns } from "./GoldenButton.vue?vue&type=template&id=7b478ce6&scoped=true&"
import script from "./GoldenButton.vue?vue&type=script&lang=js&"
export * from "./GoldenButton.vue?vue&type=script&lang=js&"
import style0 from "./GoldenButton.vue?vue&type=style&index=0&id=7b478ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b478ce6",
  null
  
)

export default component.exports